// Module
var code = "<div class=\"goreact-modal-body\" aria-label=\"Loading\" id=\"loading-modal\"><div class=\"ficon-spinner ficon-4x ficon-spin\"></div><h3 class=\"message\" translate=\"{{message}}\"></h3></div>";
// Exports
module.exports = code;